import React from 'react';
import { styled, Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { CourseDeliveryDTO } from '@beable/roster-backend-client-v1';
import { Droppable, Draggable } from '@hello-pangea/dnd';
import { getStyles } from './styles';
import ContentCourseDetails from '../../../Common/Selectors/ContentCourseDetails';

interface CourseListProps {
  title: string;
  listId: string;
  courses: CourseDeliveryDTO[];
  showSort: boolean;
}

export default function CourseList({ title, listId, courses, showSort }: CourseListProps) {
  const theme = useTheme();
  const styles = getStyles(theme);

  return (
    <Box sx={styles.courseListContainer}>
      <Typography sx={styles.courseListTitle} variant='h6'>
          { title }
      </Typography>
      <Droppable key={listId} droppableId={listId}>
        {(provided, snapshot) => (
          <div
            ref={provided.innerRef}
            {...provided.droppableProps}
          >
            <Box sx={[styles.flexDisplay, styles.grow]}>
            <Box sx={[styles.itemContainer, { backgroundColor: snapshot.isDraggingOver ? 'skyblue' : 'white' }]}>
            {
            courses.map((course, index) => {
               return (
                <Draggable key={course.courseId} draggableId={course.courseId} index={index}>
                  {provided => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      data-testid={`${listId}-item`}
                    >
                      <Box sx={styles.courseItem}>
                        <ContentCourseDetails course={course} lessons={course.lessons} sort={ showSort ? (index + 1) : undefined }/>
                      </Box>
                    </div>
                  )}
                </Draggable>
              );
            })
            }
            {provided.placeholder}
            </Box>
            </Box>
          </div>
        )}
      </Droppable>
    </Box>
  )
}